import { loadMore } from "../utils/loadMore";

function wineAcademyLoadMore () {

  const producers = document.querySelector('.js-wine-academy-homepage .js-load-more-list')

  if (producers) loadMore(producers);
}

wineAcademyLoadMore()

function wineAcademySearchFocus() {

  const searchBtn = document.querySelector('.js-academy-search-btn')
  const searchField = document.querySelector('.js-academy-search')

  searchBtn.addEventListener('click', () => {
    searchField.focus()
  })

}

wineAcademySearchFocus()
